/* eslint-disable @typescript-eslint/no-explicit-any */
import { Option, pipe } from 'effect';
import * as Array_ from 'effect/Array';
import { cluster as clusterRadash } from 'radash';
import * as Equivalence from '../Equivalence/Equivalence.js';
import { Result } from '../Result/index.js';
import { dual } from '../function/dual.js';
export * from 'effect/Array';
export const mapWithIndex = (mapFn) => (arr) => arr.map((item, index) => mapFn(item, index));
export const from = Array.from;
/**
 *  Generates inclusive range array
 */
export const range = (from, to) => {
    const result = [];
    if (from <= to) {
        for (let i = from; i <= to; i++) {
            result.push(i);
        }
    }
    else {
        for (let i = from; i >= to; i--) {
            result.push(i);
        }
    }
    return result;
};
export const splitAt = (atIndex) => (arr) => {
    return [arr.slice(0, atIndex), arr.slice(atIndex)];
};
export const uniq = (arr) => {
    if (arr.length === 1 || arr.length === 0) {
        return arr;
    }
    return [...new Set(arr)];
};
export const uniqBy = (getKey) => (arr) => {
    const set = new Set();
    const result = [];
    for (const item of arr) {
        if (set.has(getKey(item))) {
            continue;
        }
        result.push(item);
        set.add(getKey(item));
    }
    if (result.length === arr.length) {
        return arr;
    }
    return result;
};
export const find = (predicate) => (arr) => arr.find(predicate);
export const includes = (array, value) => {
    return array.includes(value);
};
export const includesWith = (equals) => (item) => (arr) => {
    return arr.some((it) => equals(it, item));
};
export const isEmpty = (arr) => arr.length === 0;
export const isNotEmpty = (arr) => arr.length > 0;
export const of = (input) => Array.isArray(input) ? input : [input];
export const concat = (additions) => (target) => {
    return [...target, ...additions];
};
export const randomElement = (array) => {
    return array[Math.floor(Math.random() * array.length)];
};
/**
 * Splits a single list into many lists of the desired size. If
 * given a list of 10 items and a size of 2, it will return 5
 * lists with 2 items each
 */
export const cluster = (size) => (array) => clusterRadash(array, size);
export const pop = (arr) => {
    const copy = [...arr];
    const item = copy.pop();
    return [item, copy];
};
export const without = (element) => (array) => {
    return pipe(array, Array_.filter((it) => it !== element));
};
export function single(arg) {
    if (Array.isArray(arg)) {
        return arg.length === 1 ? arg[0] : undefined;
    }
    return (array) => {
        const matches = array.filter(arg);
        return matches.length === 1 ? matches[0] : undefined;
    };
}
export const compact = (array) => {
    const result = array.filter((item) => item !== null && item !== undefined);
    if (result.length === array.length) {
        return array;
    }
    return result;
};
const isUpsertOptions = (obj) => {
    return (typeof obj === 'object' &&
        obj != null &&
        ('equals' in obj || 'insertMode' in obj));
};
const defaultUpsertOptions = {
    equalsIdentity: Equivalence.strictEqual(),
    equalsValue: Equivalence.strictEqual(),
    insertMode: 'append',
};
export function upsert(optionsOrItem) {
    const options = (() => {
        if (isUpsertOptions(optionsOrItem)) {
            return {
                ...defaultUpsertOptions,
                ...optionsOrItem,
            };
        }
        return defaultUpsertOptions;
    })();
    const process = (item) => {
        return (arr) => {
            const idx = arr.findIndex((x) => options.equalsIdentity(x, item));
            if (idx >= 0) {
                const currentItem = arr[idx];
                if (options.equalsValue(currentItem, item)) {
                    return arr;
                }
                const next = [...arr];
                next[idx] = item;
                return next;
            }
            // insert new
            return options.insertMode === 'prepend' ? [item, ...arr] : [...arr, item];
        };
    };
    if (isUpsertOptions(optionsOrItem)) {
        return process;
    }
    return process(optionsOrItem);
}
export const partitionMap = dual(2, (array, f) => {
    const result = {
        error: [],
        ok: [],
    };
    array.map((value, index) => {
        Result.match(f(value, index), {
            onSuccess: (x) => result.ok.push(x),
            onFailure: (x) => result.error.push(x),
        });
    });
    return result;
});
export const lastOrUndefined = (self) => Option.getOrUndefined(Array_.last(self));
export const first = (arr) => arr[0];
//# sourceMappingURL=Array.js.map